import React, { useState } from 'react'
import './App.css'
import Loader from 'react-loader-spinner'
import { MapContainer } from './components/map/map.container'
import { TitreGridContainer } from './components/titre-grid/titre-grid.container'

const App: React.FC = () => {
	const [actifTitres, setActifTitres] = useState([])
	const [loading, setLoading] = useState(false)

	const handleRegionClick = async (id: string) => {
		try {
			setActifTitres([])
			setLoading(true)

			const response = await fetch(
				`https://www.espacephr.fr/wp-json/acf/v3/cpt_431?carte_id=${id}`
			)

			const responseJson = await response.json()

			setLoading(false)

			setActifTitres(responseJson)
		} catch (e) {
			console.error(e)
			setLoading(false)
		}
	}

	return (
		<section className="flex">
			<div className="flex-1">
				<MapContainer handleClick={handleRegionClick} />
			</div>
			<div className="flex-1">
				{loading ? (
					<Loader
						type="Puff"
						color="#00BFFF"
						height={100}
						width={100}
						timeout={3000} // 3 secs
					/>
				) : (
					<></>
				)}
				{actifTitres.length > 0 ? (
					<TitreGridContainer titres={actifTitres} />
				) : (
					<></>
				)}
			</div>
		</section>
	)
}

export default App
